import TwoFactorAuthenticationModal from "./TwoFactorAuthenticationModal";

export default TwoFactorAuthenticationModal;
